<template>
  <!-- Error boundary catches config validation errors and shows user-friendly message -->
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('woff-to-woff2-converter', 'WOFF → WOFF2');

function handleBatchCreated(batchId: string) {
  console.log('[WOFF-to-WOFF2 Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[WOFF-to-WOFF2 Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[WOFF-to-WOFF2 Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[WOFF-to-WOFF2 Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[WOFF-to-WOFF2 Converter] Credits updated:', credits);
}
</script>
